import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AuthApiService } from './services/auth/auth-api.service';
import { TimeoutInterceptor } from './interceptors/timeout.interceptor';
import { LanguageService } from './services/language.service';

export function initializeTranslations(languageService: LanguageService): () => Promise<void> {
  return (): Promise<void> => languageService.initializeLanguage();
}

export function initializeAuth(authApiService: AuthApiService): () => Promise<void> {
  return (): Promise<void> => authApiService.initializeSession();
}

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    // ============================== Interceptor chain — ORDER MATTERS ==============================
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [LanguageService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthApiService],
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
